import * as React from "react";
import { SVGProps } from "react";
export const DocPencilFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.5 18C5.08333 18 4.72933 17.854 4.438 17.562C4.146 17.2707 4 16.9167 4 16.5V3.5C4 3.08333 4.146 2.72933 4.438 2.438C4.72933 2.146 5.08333 2 5.5 2H11.375C11.5697 2 11.7607 2.03467 11.948 2.104C12.1353 2.17333 12.2987 2.28467 12.438 2.438L15.562 5.562C15.7153 5.70133 15.8267 5.86467 15.896 6.052C15.9653 6.23933 16 6.43033 16 6.625V9.625L10 15.604V18H5.5ZM11.875 18C11.7777 18 11.691 17.9617 11.615 17.885C11.5383 17.809 11.5 17.7223 11.5 17.625V16.521C11.5 16.4097 11.5207 16.309 11.562 16.219C11.604 16.1283 11.6597 16.0483 11.729 15.979L15.667 12.062L17.438 13.833L13.5 17.771C13.4307 17.8403 13.3507 17.896 13.26 17.938C13.17 17.9793 13.0693 18 12.958 18H11.875ZM18.146 13.125L16.396 11.354L17.083 10.646C17.1943 10.5347 17.323 10.486 17.469 10.5C17.615 10.514 17.7433 10.5767 17.854 10.688L18.854 11.708C18.9653 11.8053 19.0243 11.9167 19.031 12.042C19.0383 12.1667 18.9933 12.2777 18.896 12.375L18.146 13.125ZM11.75 7H14.5L11 3.5V6.25C11 6.458 11.073 6.635 11.219 6.781C11.365 6.927 11.542 7 11.75 7Z"
            fill="currentColor"
        />
    </svg>
);
DocPencilFillIcon.displayName = "DocPencilFillIcon";
